// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Iu9E1","col":"styles_col__3tqGO"};